export const LOGICAL_WIDTH = 2;
export const LOGICAL_HEIGHT = 2;
